import {
    Box,
    Flex,
    Text,
    Button,
    VStack,
    Icon,
    Divider,
} from "@chakra-ui/react";
import { FiCheckCircle } from "react-icons/fi";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";

const CacheSettings = () => {
    const SIDEBAR_WIDTH = "240px";

    const cacheItems = [
        "Compiled views will be cleared",
        "Application cache will be cleared",
        "Route cache will be cleared",
        "Configuration cache will be cleared",
        "Compiled services and packages files will be removed",
        "Caches will be cleared",
    ];

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={{ base: 4, md: 8 }}
                bg="gray.50"
                minH="100vh"
                mt="64px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                {/* HEADER */}
                <Flex mb={8}>
                    <Text fontSize="xl" fontWeight="semibold" color="gray.700">
                        Clear System Cache
                    </Text>
                </Flex>

                {/* CACHE CARD */}
                <Flex justify="center" mt={4}>
                    <Box
                        bg="white"
                        borderRadius="md"
                        shadow="sm"
                        maxW="800px"
                        w="100%"
                        overflow="hidden"
                        border="1px solid"
                        borderColor="gray.100"
                    >
                        <VStack align="stretch" spacing={0}>
                            {cacheItems.map((item, index) => (
                                <Box key={index}>
                                    <Flex p={5} align="center">
                                        <Icon as={FiCheckCircle} color="green.400" mr={3} boxSize={5} />
                                        <Text color="gray.600" fontSize="lg">
                                            {item}
                                        </Text>
                                    </Flex>
                                    {index < cacheItems.length - 1 && <Divider />}
                                </Box>
                            ))}

                            <Box p={5}>
                                <Button
                                    w="100%"
                                    bg="#4f46e5"
                                    color="white"
                                    py={6}
                                    fontWeight="medium"
                                    _hover={{ bg: "#4338ca" }}
                                    _active={{ bg: "#3730a3" }}
                                >
                                    Click to clear
                                </Button>
                            </Box>
                        </VStack>
                    </Box>
                </Flex>
            </Box>
        </>
    );
};

export default CacheSettings;
